import { Component, OnInit, Inject, ViewChild, ChangeDetectorRef } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { UsuarioFinalComponent } from "../usuario-final.component";
// Service
import { FinalUserService } from "src/app/core/services/actors/finalUser.service";
// Alert
import { AlertNoticeService } from "src/app/core/alert/alert.service";

@Component({
  selector: "view-users-modal",
  templateUrl: "./view-users-modal.component.html",
  styleUrls: ["./view-users-modal.component.scss"],
})
export class ViewUsersFinalUserModal implements OnInit {
  viewModal = 1;
  createUserForm: FormGroup;
  editUserForm: FormGroup;
  closeResult: string;
  usersResult = [];
  public mask = ["(", "+", /[1-9]/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];

  displayedColumns = ["names", "lastnames", "email", "phone", "actions"];

  usersList = new MatTableDataSource();
  isLoaded: boolean = false;
  usersPageConf = {
    pageSize: [5, 10, 20, 100, 200],
    elementsPerPage: "20",
    totalItems: "20",
  };

  loading = false;
  showAlert = false;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(public dialogRef: MatDialogRef<UsuarioFinalComponent>, @Inject(MAT_DIALOG_DATA) public data, private finalUserService: FinalUserService, private cdr: ChangeDetectorRef, private fb: FormBuilder, public alert: AlertNoticeService) {}

  ngOnInit(): void {
    this.createUserForm = this.fb.group({
      id: [this.data.id, Validators.required],
      name: [, Validators.required],
      lastName: [, Validators.required],
      identification: [, Validators.required],
      phone: [, Validators.required],
      email: [, Validators.compose([Validators.required, Validators.email])],
    });
    this.editUserForm = this.fb.group({
      id: [this.data.id, Validators.required],
      name: [, Validators.required],
      lastName: [, Validators.required],
      identificationOg: [, Validators.required],
      identification: [, Validators.required],
      phone: [, Validators.required],
      email: [, Validators.compose([Validators.required, Validators.email])],
    });
    this.translatePaginatorLabel();
    this.getAllUsers();
  }

  translatePaginatorLabel() {
    this.paginator._intl.itemsPerPageLabel = "Registros por pagina";
    this.paginator._intl.getRangeLabel = (page, pageSize, length) => {
      if (length == 0 || pageSize == 0) {
        return `0 de ${length}`;
      }
      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
      return `${startIndex + 1} – ${endIndex} de ${length}`;
    };
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.usersList.filter = filterValue;
  }

  getAllUsers() {
    this.finalUserService.getAllUsersByFinalUserPaged(this.data.id, "0", "10").subscribe(
      (res: any) => {
        this.usersResult = [];
        res.content.map((item) => {
          this.usersResult.push({
            id: item.userEntity.identification,
            names: item.userEntity.names,
            lastnames: item.userEntity.lastNames,
            email: item.userEntity.email,
            phone: item.userEntity.phone,
          });
        });
        this.usersList = new MatTableDataSource(this.usersResult);
        this.isLoaded = true;
        this.usersList.sort = this.sort;
        this.usersPageConf.elementsPerPage = res.pageable.pageSize;
        this.usersPageConf.totalItems = res.totalElements;
      },
      (err) => {
        this.isLoaded = true;
      }
    );
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  updateUsers(event) {
    let size = event.pageSize.toString();
    let page = event.pageIndex.toString();
    this.finalUserService.getAllUsersByFinalUserPaged(this.data.id, page, size).subscribe(
      (res: any) => {
        this.usersResult = [];
        res.content.map((item) => {
          this.usersResult.push({
            id: item.userEntity.identification,
            names: item.userEntity.names,
            lastnames: item.userEntity.lastNames,
            email: item.userEntity.email,
            phone: item.userEntity.phone,
          });
        });
        this.usersList = new MatTableDataSource(this.usersResult);
        this.isLoaded = true;
        this.usersList.sort = this.sort;
        this.usersPageConf.elementsPerPage = res.pageable.pageSize;
        this.usersPageConf.totalItems = res.totalElements;
      },
      (err) => {
        this.isLoaded = true;
      }
    );
  }

  numberToPhone(value) {
    const d = value.split("");
    const getD = (digit) => {
      return d[digit] ? d[digit] : "";
    };
    return `(+${getD(0)}${getD(1)}) ${getD(2)}${getD(3)}${getD(4)}-${getD(5)}${getD(6)}${getD(7)}-${getD(8)}${getD(9)}${getD(10)}${getD(10)}`;
  }

  phoneToNumber(value) {
    const newValue = value.split(/[ +()-]+/);
    return newValue.join("");
  }

  changeView(view, data) {
    this.viewModal = view;
    if (data) {
      this.editUserForm.patchValue({
        name: data.names,
        lastName: data.lastnames,
        identificationOg: data.id,
        identification: data.id,
        phone: data.phone,
        email: data.email,
      });
    }
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.createUserForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  deleteUser(id) {
    this.showAlert = false;
    this.finalUserService.deleteFinalUserUser(id).subscribe(
      (_res) => {
        this.alert.setNotice("Usuario eliminado correctamente", "success");
        this.showAlert = true;
        this.isLoaded = false;
        this.getAllUsers();
        this.cdr.markForCheck();
      },
      (_err) => {
        if (_err.error.errors) {
          this.alert.setNotice(_err.error.errors[0].defaultMessage, "danger");
        } else {
          this.alert.setNotice(_err.error.message, "danger");
        }
        this.showAlert = true;
        this.cdr.markForCheck();
      }
    );
  }

  addUser(form) {
    this.loading = true;
    this.showAlert = false;
    if (form.valid) {
      const data = {
        id: form.value.id,
        name: form.value.name,
        lastName: form.value.lastName,
        identification: form.value.identification,
        phone: this.phoneToNumber(form.value.phone),
        email: form.value.email,
      };
      this.finalUserService.createFinalUserUser(data).subscribe(
        (_res) => {
          this.alert.setNotice("Usuario añadido correctamente", "success");
          this.showAlert = true;
          this.loading = false;
          this.createUserForm.reset();
          this.viewModal = 1;
          this.isLoaded = false;
          this.getAllUsers();
          this.cdr.markForCheck();
        },
        (_err) => {
          this.loading = false;
          if (_err.error.errors) {
            this.alert.setNotice(_err.error.errors[0].defaultMessage, "danger");
          } else {
            this.alert.setNotice(_err.error.message, "danger");
          }
          this.showAlert = true;
          this.cdr.markForCheck();
        }
      );
    } else {
      Object.keys(form.controls).forEach((controlName) => form.controls[controlName].markAsTouched());
    }
  }

  editUser(form) {
    this.loading = true;
    this.showAlert = false;
    if (form.valid) {
      const data = {
        id: form.value.id,
        name: form.value.name,
        lastName: form.value.lastName,
        identification: form.value.identification,
        phone: this.phoneToNumber(form.value.phone),
        email: form.value.email,
      };
      this.finalUserService.editFinalUserUser(data, form.value.identificationOg).subscribe(
        (_res) => {
          //
          this.alert.setNotice("Usuario editado correctamente", "success");
          this.showAlert = true;
          this.loading = false;
          this.editUserForm.reset();
          this.viewModal = 1;
          this.isLoaded = false;
          this.getAllUsers();
          this.cdr.markForCheck();
        },
        (_err) => {
          this.loading = false;
          if (_err.error.errors) {
            this.alert.setNotice(_err.error.errors[0].defaultMessage, "danger");
          } else {
            this.alert.setNotice(_err.error.message, "danger");
          }
          this.showAlert = true;
          this.cdr.markForCheck();
        }
      );
    } else {
      Object.keys(form.controls).forEach((controlName) => form.controls[controlName].markAsTouched());
    }
  }
}
